<template>
  <v-layout fill-height column>
    <v-container flex-fill>
      <div class="question pt-9 pb-10" v-html="ques[0]"></div>
      <v-radio-group v-model="answer" class="radio-group px-5">
        <v-radio
            v-for="n in replyArr.length"
            :key="n"
            :label="replyArr[n-1]"
            :value="replyObjArr[n-1]"
            :ripple="false"
            :readonly="cmplt"
        ></v-radio>
      </v-radio-group>
      <!-- 라디오 버튼 -->
    </v-container>
    <FooterBtnsNext  @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import store from '../../../store'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  data: () => ({
    answer:null,
    disabledNext:true,
    free: 'N',
    cmplt:false,
    ques:[],
    replyArr:[],
    replyObjArr:[],
    userReplyNo:[0],
    userReply:[],
  }),
  computed: {
  },
  components: {
    FooterBtnsNext,

  },
  mounted () {
    // this.userReply = this.
  },
  watch: {
    answer(){
      if(this.answer == undefined){
        this.disabledNext = true
      } else{
        this.disabledNext = false
      }
    },
    current(){
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.answer=null,
      this.disabledNext=true,
      this.free= 'N',
      this.cmplt=false,
      this.ques=[],
      this.replyArr=[],
      this.replyObjArr=[],
      this.userReplyNo=[0],
      this.userReply=[],
      this.getUnitDetailUse()
    }
  },
  created () {
    this.getUnitDetailUse()
  },
  methods:{
    async getUnitDetailUse () {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
            {'freeYn':this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl,i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                this.replyObjArr.forEach((replyObj,k) => {
                  if(replyObj.reply == userReplyEl.reply ){
                    this.answer = this.replyObjArr[k]
                  }
                })
              });
            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {})
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅

        // 라디오 답변
        let replyObj = this.answer
        this.userReply[0] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

                                memberUnitDtlReplyUseNo: this.userReplyNo[0],
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: replyObj.reply,
                                // score: score/10,
                                freeYn: this.free
                              }
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
  }
};
</script>
